export default "__VITE_ASSET__UkGEmPmh__"